import React, { useEffect, useState } from 'react';
import AuthLayout from "../layouts/AuthLayout";
import AuthMoldel from '../models/AuthMoldel';
import AppCookie from '../helpers/AppCookie';
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Link, useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";
import { setShowPreloader } from '../redux/action';
import { useDispatch } from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { FiUser, FiLock, FiEye, FiEyeOff, FiArrowRight } from 'react-icons/fi';
import { FaTelegram } from 'react-icons/fa';
import { RiBuilding4Line, RiSunLine, RiMoonLine } from 'react-icons/ri';
import './auth-modern.css';

const loginSchema = Yup.object().shape({
    name_login: Yup.string().max(255, "Tối đa 255 kí tự").required("Vui lòng nhập tài khoản hoặc email"),
    password: Yup.string().min(6, "Tối thiểu 6 kí tự").max(255, "Tối đa 255 kí tự").required("Vui lòng nhập mật khẩu")
});

function LoginPage() {
    const [showNotice, setShowNotice] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [themeMode, setThemeMode] = useState(() => {
        try {
            const saved = localStorage.getItem('wus_theme_mode');
            return saved === 'dark' || saved === 'light' ? saved : 'dark';
        } catch (e) {
            return 'dark';
        }
    });
    const browserInfo = navigator.userAgent;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    let isLoggedin = AuthMoldel.checkAuth();

    useEffect(() => {
        if (isLoggedin) navigate('/');
    }, [isLoggedin, navigate]);

    useEffect(() => {
        document.documentElement.setAttribute('data-theme-mode', themeMode);
        if (document.body) document.body.setAttribute('data-theme-mode', themeMode);
    }, [themeMode]);

    const handleToggleTheme = () => {
        const nextMode = themeMode === 'light' ? 'dark' : 'light';
        try {
            localStorage.setItem('wus_theme_mode', nextMode);
        } catch (e) {}
        document.documentElement.setAttribute('data-theme-mode', nextMode);
        if (document.body) document.body.setAttribute('data-theme-mode', nextMode);
        setThemeMode(nextMode);
    };

    const [form] = useState({ name_login: "", password: "", type_web: "web", browserInfo: browserInfo });
    
    const handleSubmit = (values) => {
        dispatch(setShowPreloader(true));
        AuthMoldel.login(values).then((res) => {
            dispatch(setShowPreloader(false));
            if (res.success === false) {
                Swal.fire({ icon: "error", title: res.message, showConfirmButton: false, timer: 2000 });
            } else {
                sessionStorage.removeItem("hasSeenComboPromo");
                sessionStorage.setItem("showComboPromoOnLogin", "true");
                AppCookie.setLoginCookie(res);
                navigate('/');
            }
        }).catch(() => {
            dispatch(setShowPreloader(false));
            Swal.fire({ icon: "error", title: "Đăng nhập thất bại", showConfirmButton: false, timer: 2000 });
        });
    };

    return (
        <AuthLayout>
            <Modal show={showNotice} onHide={() => setShowNotice(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title style={{ color: "var(--wus-warning-text)", fontWeight: 600, fontSize: "15px" }}>⚠️ THÔNG BÁO QUAN TRỌNG</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: "20px" }}>
                    <p style={{ fontSize: "14px", marginBottom: "12px", color: "var(--wus-text)" }}>
                        Toàn bộ tài khoản đã được reset mật khẩu về: <strong style={{ fontSize: "16px", color: "var(--wus-info-text)" }}>123321A</strong>
                    </p>
                    <p style={{ color: "var(--wus-text-subtle)", fontSize: "13px", marginBottom: "0" }}>
                        Vui lòng đăng nhập bằng tài khoản cũ, sau đó vào mục <strong>"Đổi mật khẩu"</strong> để thay đổi mật khẩu mới.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowNotice(false)}>Đã hiểu</Button>
                </Modal.Footer>
            </Modal>

            <div className="auth-modern-wrapper">
                <div className="auth-theme-toggle-wrap">
                    <button
                        type="button"
                        className="wus-theme-toggle-btn"
                        onClick={handleToggleTheme}
                        title={themeMode === 'light' ? 'Chuyển sang Giao diện Tối' : 'Chuyển sang Giao diện Sáng'}
                    >
                        {themeMode === 'light' ? (
                            <>
                                <RiMoonLine size={15} />
                                <span className="wus-theme-toggle-label">Giao diện Tối</span>
                            </>
                        ) : (
                            <>
                                <RiSunLine size={15} />
                                <span className="wus-theme-toggle-label">Giao diện Sáng</span>
                            </>
                        )}
                    </button>
                </div>

                <div className="auth-modern-card">
                    {/* Brand Logo */}
                    <div className="auth-brand-logo">
                        <div
                            className="brand-icon"
                            style={{
                                background: 'linear-gradient(135deg, #2563eb 0%, #4f46e5 55%, #7c3aed 100%)',
                                border: '1px solid rgba(255,255,255,0.22)',
                                boxShadow: '0 4px 12px rgba(79, 70, 229, 0.35)'
                            }}
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 2L3 6.5V11.5C3 16.85 6.84 21.74 12 23C17.16 21.74 21 16.85 21 11.5V6.5L12 2Z" stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="rgba(255,255,255,0.12)" />
                                <path d="M8 9.5H16M12 9.5V16.5M9.5 13.5L12 16.5L14.5 13.5" stroke="#fde047" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <div className="brand-name">
                            Bank<span style={{ color: '#4f46e5', fontWeight: 700 }}>TaAnhTu</span>
                        </div>
                    </div>

                    <div className="auth-form-header">
                        <h2>Đăng nhập</h2>
                        <p>Hệ thống quản lý tài khoản &amp; dịch vụ bank ảo</p>
                    </div>

                    <Formik initialValues={form} validationSchema={loginSchema} onSubmit={handleSubmit}>
                        {({ errors, touched }) => (
                            <Form>
                                <div className="auth-input-group">
                                    <label className="auth-input-label" htmlFor="name_login">Tài khoản hoặc Email</label>
                                    <div className="auth-input-wrapper">
                                        <FiUser className="auth-input-icon" />
                                        <Field 
                                            type="text" 
                                            name="name_login" 
                                            placeholder="username hoặc email" 
                                            className="auth-input-control" 
                                            autoComplete="username"
                                        />
                                    </div>
                                    {errors.name_login && touched.name_login && (
                                        <div className="auth-error-text">{errors.name_login}</div>
                                    )}
                                </div>

                                <div className="auth-input-group">
                                    <label className="auth-input-label" htmlFor="password">Mật khẩu</label>
                                    <div className="auth-input-wrapper">
                                        <FiLock className="auth-input-icon" />
                                        <Field 
                                            type={showPassword ? "text" : "password"} 
                                            name="password" 
                                            placeholder="••••••••" 
                                            className="auth-input-control" 
                                            autoComplete="current-password"
                                        />
                                        <button 
                                            type="button" 
                                            className="auth-password-toggle"
                                            onClick={() => setShowPassword(!showPassword)}
                                            tabIndex="-1"
                                            title={showPassword ? "Ẩn mật khẩu" : "Hiện mật khẩu"}
                                        >
                                            {showPassword ? <FiEyeOff size={16} /> : <FiEye size={16} />}
                                        </button>
                                    </div>
                                    {errors.password && touched.password && (
                                        <div className="auth-error-text">{errors.password}</div>
                                    )}
                                </div>

                                <button type="submit" className="auth-btn-primary">
                                    <span>Đăng Nhập</span>
                                    <FiArrowRight size={16} />
                                </button>

                                <div className="auth-switch-link-wrapper">
                                    Chưa có tài khoản?
                                    <Link to="/register" className="auth-switch-link">Đăng ký mới</Link>
                                </div>

                                <div className="auth-footer-support">
                                    <a 
                                        href="https://t.me/okbillcave" 
                                        target="_blank" 
                                        rel="noopener noreferrer" 
                                        className="auth-tele-link"
                                        title="Liên hệ hỗ trợ Admin qua Telegram"
                                    >
                                        <span className="auth-tele-icon"><FaTelegram size={16} /></span>
                                        <span>Hỗ trợ Telegram</span>
                                    </a>
                                    <span className="auth-author-text">By: JameBond007</span>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </AuthLayout>
    );
}

export default LoginPage;
